import { BlockWrapper, ChildrenBlock, defineBlock, smartProps } from '@smartfire/js-block-engine';
import { EditableImg } from '@smartfire/components';
import style from './block.module.scss';

const Group = () => {
    return (
        <BlockWrapper.Div className={style.block}>
            {/* pour que l'image garde sa taille d'origine je l'ai mis dans un container */}
            <div className={style.imageContainer}>
                <EditableImg smartProp="image" />
            </div>
            <ChildrenBlock
                className={style.children}
                gutenbergEditorConfig={{
                    allowedBlocks: ['core/heading', 'core/paragraph', 'smartfire/button'],
                    template: [['core/heading'], ['core/paragraph'], ['smartfire/button']],
                }}
            />
        </BlockWrapper.Div>
    );
};

export default defineBlock({
    Block: Group,
    smartProps: {
        image: smartProps.image,
    },
    setup: {
        title: 'Groupe',
        parent: ['smartfire/groups'],
    },
});
